import { Spin } from 'antd';
import AuthLayout, { AuthCard } from '../layout/AuthLayout';
import AppVersion from '../../components/AppVersion';
import { useSignOut } from 'react-auth-kit';
import { useEffect } from 'react';

const Logout = () => {
  const signOut = useSignOut();

  useEffect(() => {
    signOut();
  }, []);

  return (
    <AuthLayout>
      <AuthCard bordered={false}>
        <Spin />
        <AppVersion />
      </AuthCard>
    </AuthLayout>
  );
};

export default Logout;
